import { mulberry32 } from "./rng";

// Pre-Flight Check (docs/design/HUB.md §Room 3): five rapid yes/no
// questions before launch. All five right = the crew chief's blessing —
// one extra flare. The questions teach the game's real systems.

export type PreflightQuestion = {
  q: string;
  yes: boolean; // whether YES is the correct answer
};

export const PREFLIGHT_QUESTIONS: readonly PreflightQuestion[] = [
  { q: "THE 25MM LOCKS OUT FOR FIVE SECONDS WHEN OVERHEATED.", yes: true },
  { q: "THE 30MM RELOADS AFTER SIX ROUNDS.", yes: true },
  { q: "SUSTAINED 25MM FIRE WILL KILL A TANK.", yes: false },
  { q: "FLARES CAN DECOY A MANPADS MISSILE.", yes: true },
  { q: "AA GUNS HIT HARDEST AT LOW ALTITUDE.", yes: true },
  { q: "HIGH ALTITUDE TIGHTENS WEAPON DISPERSION.", yes: false },
  { q: "FRIENDLY FIRE IS DEDUCTED FROM OPS AT DEBRIEF.", yes: true },
  { q: "TRUCKS DEPLOY THEIR INFANTRY WHEN DESTROYED.", yes: true },
  { q: "FORTIFIED POSITIONS TAKE FULL BLAST DAMAGE.", yes: false },
  { q: "THE ORBIT CAN BE PARKED OVER THE ENEMY WITHOUT WAKING THEIR GUNS.", yes: false },
  { q: "A STALL WARNING MEANS ORBIT SPEED IS TOO LOW.", yes: true },
  { q: "WOUNDED OPERATORS SIT OUT THE NEXT OPERATION.", yes: true },
];

export const PREFLIGHT_LENGTH = 5;

export function pickPreflight(seed: number): PreflightQuestion[] {
  const rng = mulberry32(seed >>> 0);
  const pool = [...PREFLIGHT_QUESTIONS];
  const picked: PreflightQuestion[] = [];
  for (let i = 0; i < PREFLIGHT_LENGTH; i++) {
    const idx = Math.floor(rng() * pool.length) % pool.length;
    picked.push(pool.splice(idx, 1)[0]!);
  }
  return picked;
}
